import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './LimitExceededModal.css';
import { PaymentModal } from './PaymentModal';
import { PAYMENTS_ENABLED } from '../i18n';

function LimitExceededModal({ onClose, isOpen }) {
  const { t } = useTranslation();
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);

  const handleBuyCredits = () => {
    setIsPaymentModalOpen(true);
  };

  const handleClose = () => {
    setIsPaymentModalOpen(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="modal-overlay">
        <div className="modal-content">
          <h2>{t('limitModal.title')}</h2>
          <p>{t('limitModal.desc1')}</p>
          {PAYMENTS_ENABLED && <p>{t('limitModal.desc2')}</p>}
          <div className="modal-buttons">
            {PAYMENTS_ENABLED && (
              <button className="modal-button primary" onClick={handleBuyCredits}>
                {t('limitModal.buy')}
              </button>
            )}
            <button className="modal-button secondary" onClick={handleClose}>
              {t('limitModal.close')}
            </button>
          </div>
        </div>
      </div>

      {PAYMENTS_ENABLED && (
        <PaymentModal
          isOpen={isPaymentModalOpen}
          onClose={() => {
            setIsPaymentModalOpen(false);
            onClose();
          }}
        />
      )}
    </>
  );
}

export default LimitExceededModal; 